// removed by extract-text-webpack-plugin
module.exports = {"inputWrapper":"c-PersonalIdentityNumber__inputWrapper","input":"c-PersonalIdentityNumber__input"};